import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { listOnboardings, saveOnboarding, updateOnboardingStep } from "../../../../services/platform_admin_service";

const usePlatformOnboarding = () => {
    const [items, setItems] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const selected = items.find(o => o.id === selectedId) || items[0] || null;

    const fetchOnboardings = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const result = await listOnboardings();
            const list = result.items || [];
            setItems(list);
            if (!selectedId && list.length > 0) setSelectedId(list[0].id);
        } catch (err) {
            console.error("[usePlatformOnboarding]", err);
            setError(err.message || "Erro ao carregar onboardings.");
        } finally {
            setLoading(false);
        }
    }, [selectedId]);

    useEffect(() => {
        fetchOnboardings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleStep = async (onboardingId, stepId) => {
        const onboarding = items.find(o => o.id === onboardingId);
        if (!onboarding) return;
        const step = (onboarding.steps || []).find(s => s.id === stepId);
        if (!step) return;
        const newChecked = !step.checked;
        try {
            const result = await updateOnboardingStep(onboardingId, stepId, newChecked);
            setItems(prev => prev.map(o => o.id === onboardingId
                ? { ...o, steps: result.steps, status: result.status }
                : o
            ));
            toast.success(newChecked ? "Etapa marcada como concluída." : "Etapa desmarcada.");
        } catch (err) {
            const msg = err.message || "Erro ao atualizar etapa.";
            setError(msg);
            toast.error(msg);
        }
    };

    const createOnboarding = async (data) => {
        try {
            const result = await saveOnboarding(data);
            await fetchOnboardings();
            setSelectedId(result.id);
            toast.success("Onboarding criado com sucesso!");
            return result;
        } catch (err) {
            const msg = err.message || "Erro ao criar onboarding.";
            setError(msg);
            toast.error(msg);
            throw err;
        }
    };

    return {
        items,
        selected,
        selectedId,
        loading,
        error,
        setSelectedId,
        toggleStep,
        createOnboarding,
        refetch: fetchOnboardings,
    };
};

export default usePlatformOnboarding;
